/* eslint-disable indent */
import styled from 'styled-components';

interface ButtonProps {
  $isActive: boolean;
}

export const ButtonContainer = styled.button<ButtonProps>`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  gap: ${(props) => props.theme.spacing(1)}px;
  width: 100%;
  padding-inline: ${(props) => props.theme.spacing(2)}px;
  padding-block: ${(props) => props.theme.spacing(1)}px;
  background-color: ${(props) =>
    props.$isActive ? props.theme.colors.primary : props.theme.colors.backgroundPrimary};
  border-radius: 6.25rem;
  border: 1px solid ${(props) => props.theme.colors.primary};
  color: ${(props) =>
    props.$isActive ? props.theme.colors.backgroundPrimary : props.theme.colors.primary};
  font-size: ${(props) => props.theme.typography5.fontSize};
  font-weight: ${(props) => props.theme.typography5.fontWeight};
  line-height: ${(props) => props.theme.typography5.lineHeight};

  &:hover {
    background-color: ${(props) =>
      props.$isActive ? props.theme.colors.hover : props.theme.colors.primary};
    color: ${(props) => props.theme.colors.backgroundPrimary};

    svg {
      fill: ${(props) => props.theme.colors.backgroundPrimary};
    }
  }

  &:active {
    background-color: ${(props) => props.theme.colors.active};
    color: ${(props) => props.theme.colors.backgroundPrimary};

    svg {
      fill: ${(props) => props.theme.colors.backgroundPrimary};
    }
  }
`;

export const IconContainer = styled.span<ButtonProps>`
  display: flex;
  svg {
    fill: ${(props) =>
      props.$isActive ? props.theme.colors.backgroundPrimary : props.theme.colors.primary};
  }
`;
